import ApiConstant from "../../../constants/api.constants";
import ConsoleType from "../../../constants/console-type.constant";
import Helpers from "../../../utils/helpers";
import api from "../../api";
import sites_table from "./data/table.json";
import sites_map from "./data/sites_map_details.json";
import axios from "axios";

const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA;

const getSurveyList = async (CustID: any, Year: any) => {
  let apiValues = "?Year=" + Year;

  if (CustID) {
    apiValues = apiValues + "&CustomerID=" + CustID;
  }
  return await api
    .get(ApiConstant.GetAOGIAllSurveyDetails + apiValues)
    .then(function (response: any) {
      return response.data;
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, ConsoleType.Error);
    });

  // let apiValues = '?SurveyYear=';
  //   let apiValues = '?SurveyYear=' + survey.surveyDate?.getFullYear();

  //   if (survey.customerID) {
  //     apiValues = apiValues + '&customerId=' + survey.customerID;
  //   }

  //   return await api
  //     .get(ApiConstant.getAOGISurveys + apiValues)
  //     .then(function (response: any) {
  //       return response.data;
  //     })
  //     .catch(function (error) {
  //       Helpers.ConsoleLog(error, ConsoleType.Error);
  //     });
};

const SitesTableData = async () => {
  return await new Promise((resolve, reject) => {
    resolve(sites_table.data);
  });
};

/* const SitesTableApiData = async () => {
  return await api
    //.get(baseURL + ApiConstant.GetSiteSummary)
    .get("http://localhost:3000/data/")
    .then(function (response: any) {
      return response.data;
    })
    .catch(function (error) {
      Helpers.ConsoleLogError(error);
    });
}; */

const SitesTableApiData = async () => {
  try {
    const response = await api.get(baseURL + ApiConstant.SiteSummary);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    return "error"
  }
};

const SitesOnboradPostApiData = async (data: any) => {
  try {
    const response = await api.post(
      baseURL + ApiConstant.addSiteSummary,
      data
    );
    
    if (response && response.data) {
      return response.data;
    }
  } catch (error:any) {
    return "error"
  }
};

const SitesOnboradUpdateApiData = async (data: any, id: any) => {
  try {
    const response = await api.put(
      baseURL + ApiConstant.postUpdateSiteSummary + id,
      data
    );
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const SitesMapData = async () => {
  return await new Promise((resolve, reject) => {
    resolve(sites_map);
  });
};

const sitesGetAllCustomers = async (cusId?: any) => {
  try {
    const response = await api.get(baseURL + ApiConstant.getAllCustomers);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const SitesService = {
  getSurveyList,
  SitesTableData,
  SitesTableApiData,
  SitesOnboradPostApiData,
  SitesOnboradUpdateApiData,
  SitesMapData,
  sitesGetAllCustomers,
};

export default SitesService;
